import type {GenericContent} from '../../../../../../brand/lib/types/contentful'

import {WebGLHero} from '../../_shared/WebGL/WebGLHero/WebGLHero'
import {Media} from '../Media/Media'
import {FooterVisual} from '../../_shared/FooterVisual/FooterVisual'
import {PageDivider} from '../../_shared/PageDivider/PageDivider'

type Props = {
  content: GenericContent
  location: string
  sectionIndex: number
}

export function Visual({content, location, sectionIndex}: Props) {
  const {htmlId, media} = content.fields

  const fallbackImage = media?.find(asset => asset.fields.asset.fields.file.details?.image)

  if (htmlId === 'hero') {
    return (
      <WebGLHero
        fallback={<Media content={content} location={location} sectionIndex={sectionIndex} loading="eager" />}
      />
    )
  }

  if (htmlId === 'footer') {
    return <FooterVisual fallbackImage={fallbackImage} />
  }

  if (htmlId === 'divider1') {
    return <PageDivider type={1} />
  }

  if (htmlId === 'divider2') {
    return <PageDivider type={2} />
  }

  if (htmlId === 'divider3') {
    return <PageDivider type={3} />
  }

  return null
}
